import { CSSProperties, ReactNode } from "react";
import { usePalette } from "@/shared/theme";
import { Dot } from "@/modules/common/shared/notification/ui/dot";

export function NotificationListItemContainer({
  children,
  read,
}: {
  children: ReactNode;
  read?: boolean;
}) {
  const palette = usePalette();

  return (
    <div
      className={"p-4 xl:pl-6 bg-[--bg] relative"}
      style={
        {
          "--bg": read ? "white" : palette.neutral[0],
        } as CSSProperties
      }
    >
      {!read && <Dot className={"absolute top-2 right-2"} />}
      {children}
    </div>
  );
}
